import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicMove({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8.75 1.96c.92 0 1.67.7 1.74 1.6l.01.15v.8a.75.75 0 11-1.5 0v-.8a.25.25 0 00-.2-.24l-.05-.01h-5a.25.25 0 00-.24.2l-.01.05v8.58c0 .11.08.21.2.24h5.05c.12 0 .22-.08.24-.19L9 12.3v-.81a.75.75 0 011.5 0v.8c0 .92-.7 1.68-1.6 1.75H3.74c-.92 0-1.67-.7-1.74-1.6V3.7c0-.92.7-1.67 1.6-1.74l.15-.01h5zm3.75 2.97c.2 0 .35.1.5.2l2.5 2.25a.8.8 0 01.25.55c0 .2-.1.4-.25.55L13 10.73c-.15.15-.3.2-.5.2a.77.77 0 01-.75-.75c0-.2.1-.4.25-.55l1.05-.95H7.5a.77.77 0 01-.75-.75c0-.4.35-.75.75-.75h5.55L12 6.23a.8.8 0 01-.25-.55c0-.4.35-.75.75-.75z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicMove.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicMove.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicMove svgRef={ref} {...props} />);
export default ForwardRef;
